export default "__VITE_ASSET__BiAWICLO__"